varying float vProgress;

void main() {
    vec2 uv = gl_PointCoord;
    vec3 colorWhite = vec3(1.0, 1.0, 1.0);
    vec3 colorBlack = vec3(0.1, 0.1, 0.1);
    vec2 d = uv - vec2(0.5);
    float r = length(d);
    float alpha = smoothstep(0.5, 0.5 - 0.02, r);
    if (alpha <= 0.0) discard;

    float colorProgress = smoothstep(0.0, 0.05, vProgress);
    if(vProgress > 0.95) {
      colorProgress = 1.0 - smoothstep(0.9, 1.0, vProgress);
    }

    vec3 finalColor = mix(colorBlack, colorWhite, colorProgress);

    gl_FragColor = vec4(finalColor, alpha);
}